import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Step } from '../../models';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
    standalone: false
})
export class StepperComponent {
  @Input() currentStep = 2;
  @Input() profile = false;

  @Output() compleInfoClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() profileData: EventEmitter<number> = new EventEmitter<number>();

  isActive = true;
  isActive2 = false;
  completeInfoButtonClicked = false;
  readonly step = Step;

  onCompleteInfoClicked() {
    this.completeInfoButtonClicked = !this.completeInfoButtonClicked;
    this.compleInfoClicked.emit(true);
  }
  onProfile(data: number) {
    this.profileData.emit(data);
  }
}
